/** H5 图片地址：字符串 URL、静态 import、或 RN 遗留 { uri } */
export type ImageSrcInput =
  | string
  | number
  | { uri?: string; default?: unknown }
  | null
  | undefined

/** 将 src / source 统一解析为 <img src> 可用的 URL */
export function resolveImageSrc(src?: ImageSrcInput, legacySource?: ImageSrcInput): string {
  const value = src ?? legacySource
  if (value == null) return ""
  if (typeof value === "string") return value
  if (typeof value === "number") return String(value)
  if (typeof value === "object") {
    if (typeof value.uri === "string") return value.uri
    if (typeof value.default === "string") return value.default
  }
  return ""
}
